import { FC, PropsWithChildren, memo } from 'react';
import styled, { useTheme } from 'styled-components';
import { typography } from '@clds/typography';

export const Text = styled.div`
  ${typography.xs.contrastInvert};
  color: ${(props) => props.theme.color.white};
  line-height: 25px;
  text-transform: uppercase;
`;

const Rectangle = styled.div<{ backgroundColor: string }>`
  width: 25px;
  height: 25px;
  background: ${({ backgroundColor }) => backgroundColor};
  border-radius: 4px;
  text-align: center;
  margin: auto 0;
`;
interface AvatarColorRectangleProps {
  productEnvironment: string;
}

export const ProductEnvironmentAvatar: FC<PropsWithChildren<AvatarColorRectangleProps>> = memo(({ productEnvironment = '' }) => {
  const theme = useTheme();
  // @ts-ignore @fe-infra This error will disappear after full migration - it's caused by cross-app imports
  const defaultColor = theme.palette.primary;
  const text = productEnvironment.substring(0, 2);
  return (
    <Rectangle backgroundColor={defaultColor}>
      <Text>{text}</Text>
    </Rectangle>
  );
});
